import { render, staticRenderFns } from "./BtnTransfer.vue?vue&type=template&id=fa074f1a&scoped=true&"
import script from "./BtnTransfer.vue?vue&type=script&lang=js&"
export * from "./BtnTransfer.vue?vue&type=script&lang=js&"
import style0 from "./BtnTransfer.vue?vue&type=style&index=0&id=fa074f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa074f1a",
  null
  
)

export default component.exports